import { ArticleHeading1 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface IOfferSummaryInfoGroupProps {
  header: string;
  rightGroup?: boolean;
  subscribeBtn?: React.ReactNode | null;
  children: React.ReactNode;
}

export const OfferSummaryInfoGroup: React.FC<IOfferSummaryInfoGroupProps> = ({
  header,
  rightGroup,
  subscribeBtn,
  children,
}) => {
  return (
    <div data-testid="OfferSummaryInfoGroup" className={cn(styles['group'], rightGroup && styles['right'])}>
      <div className={styles['header']}>
        <ArticleHeading1 as="h2" color="black_100">
          {header}
        </ArticleHeading1>

        {subscribeBtn && subscribeBtn}
      </div>

      <div>{children}</div>
    </div>
  );
};
